import { Injectable } from '@angular/core';
import {ToastController} from '@ionic/angular';
import {Tag} from '../models/contact/contactRes';

@Injectable({
  providedIn: 'root'
})
export class UiHelperService {

  constructor(
    private toastController: ToastController
  ) { }
  getStateColor(state: string): string{
    switch(state) {
      case '19358' : //1 - Dodjela termina
      case '19388' : //2 - Potvrđeno od strane menadžera
        return 'warning';

      case '19333' : //3 - Odradena prezentacije
      case '20155' : //4 - Prezentacija s poslanom ponudom
      case '19334' : //5 - Prezentacija s prodajom
        return 'success';

      case '19347' : //6 - Prezentacija odgođena
      case '19389' : //7 - Prezentacija otkazana
        return 'danger';

      default:
        return 'danger';
    }
  }


  async presentToast(msg: string) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 10000
    });
    await toast.present();
  }

  enhanceTags(allTags: Tag[], contactTags: number[] | Tag[]) {
    if (contactTags){
      return contactTags.map(contactTag =>
        allTags.find(tag => Number(tag.id) === Number(contactTag))
      );
    }
  }

  normalizeString(str: string){
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^A-Z0-9]+/ig, '_');
  }

  cloneObject(obj) {
    if (obj === null || typeof (obj) !== 'object' || 'isActiveClone' in obj) {
      return obj;
    }
    let temp;
    if (obj instanceof Date)
      {
        // @ts-ignore
        temp = new obj.constructor();
      }
    else
      {
        temp = obj.constructor();
      }

    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        obj.isActiveClone = null;
        temp[key] = this.cloneObject(obj[key]);
        delete obj.isActiveClone;
      }
    }
    return temp;
  }
}
